import { Popover } from './Popover';

const components = {
  Popover,
};

export default components;
